import type { SectionTreeDocLeaf } from '@/components/compiler/SectionTree';
import { isLowConfidence, LOW_CONFIDENCE_THRESHOLD } from '@/lib/confidence';

/**
 * phase-ui-tree-leaf-review-capsules — ONE predicate for both the document
 * leaves and the section roll-up (CompilerPage's badge sets import this), so
 * the two surfaces can never disagree about what needs review.
 *
 * `unconfirmed`: ConfirmedAt strictly null (the API always sends the field;
 * an absent field means the caller passed a minimal shape — no capsule).
 *
 * `lowConfidence`: delegated to `lib/confidence`.
 *
 * phase-compiler-screen-batch item 2 — this used to read `ConfidenceScore`
 * directly. That column is legacy: the current classifier writes
 * `ClassificationConfidence` and leaves `ConfidenceScore` at 0, so every
 * AI-classified document read as 0% here and got an amber "low conf." badge
 * while the Inspector — reading the other column — showed "HIGH — 92%" for the
 * same file. The scale normalisation here was always correct; the column was
 * not. `lib/confidence` now owns both the column precedence and the bands, and
 * every consumer goes through it.
 */
export { LOW_CONFIDENCE_THRESHOLD };

export function docReviewFlags(doc: SectionTreeDocLeaf): {
  unconfirmed: boolean;
  lowConfidence: boolean;
} {
  return {
    unconfirmed: doc.ConfirmedAt === null,
    lowConfidence: isLowConfidence(doc),
  };
}
